import React, { ChangeEvent, useRef, useEffect } from 'react'

import { Button, Input, Row, Span } from 'components'
import { useModal } from 'hooks'
import { SPACING } from 'utils'
import { COLORS } from 'utils'

import { ContainerInput, IInputFileStyles } from './InputFile.styles'

interface IInputFile extends IInputFileStyles {
  placeholder?: string
  value?: any[] | undefined
  widthInput?: string
  onChange?: (_data: any) => void
  required?: boolean
  renderInput?: boolean
  error?: string
  multiple?: boolean
  fileNameProp?: string
  disabled?: boolean
  allowLastFile?: boolean
  acceptFiles?: string | undefined
  disabledInput?: boolean
}

const InputFile: React.FC<IInputFile> = ({
  placeholder,
  value,
  error,
  widthInput,
  alignItems,
  gap,
  justifyContent,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  onChange,
  required,
  renderInput = true,
  multiple = true,
  fileNameProp = 'name',
  disabled = false,
  allowLastFile = true,
  acceptFiles = undefined,
  disabledInput,
}) => {
  const { showModal } = useModal()
  const inputRef = useRef(null)

  const handleClick = () => {
    inputRef?.current?.click()
  }

  const handleReset = () => {
    inputRef.current.value = ''
  }

  const fileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const limitUpload = 2000000000 // 2GB
    if (event?.target?.files[0].size >= limitUpload) {
      showModal({
        type: 'alert',
        message: 'Limite para o tamanho do arquivo atingido: 2GB portanto arquivo não pode ser anexado',
        hideButtonCancel: true,
        txtButtonConfirm: 'OK'
      })

      return
    }
    
    onChange(event.target.files)
  }

  return (
    <ContainerInput
      justifyContent={justifyContent}
      alignItems={alignItems}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      gap={gap}
      onClick={disabled ? null : handleClick}
    >
      <Row alignItems="center" justifyContent="start">
        <input
          type="file"
          ref={inputRef}
          onChange={fileChange}
          onClick={allowLastFile ? handleReset : null}
          multiple={multiple}
          accept={acceptFiles ? acceptFiles : null}
          autoComplete="off"
        />
        <Row alignItems="center" justifyContent="start" flexWrap="nowrap">
          <Button
            text="Upload"
            marginRight={SPACING.spacing15}
            disabled={disabled}
          />
          {renderInput && (
            <Input
              required={required}
              disabled={disabledInput}
              placeholder={
                placeholder
                  ? placeholder
                  : multiple
                    ? 'Selecione os arquivos'
                    : 'Selecione um arquivo'
              }
              width={widthInput}
              value={
                multiple
                  ? value
                    ? Object.entries(value)
                      .map(([_, value]) => value[fileNameProp] || undefined)
                      .join(', ')
                    : undefined
                  : value?.length > 0
                    ? value[0][fileNameProp] || ''
                    : ''
              }
            />
          )}
        </Row>
      </Row>
      {error && (
        <Span marginTop={SPACING.spacing5} text={error} color={COLORS.error} />
      )}
    </ContainerInput>
  )
}

export default InputFile
